<template>
  <div>
    <firma-archivo v-on:documento-firmado="documentoFirmado"></firma-archivo>
    <mail-archivo v-show="mailVisible" :documento="idDocumento"></mail-archivo>
  </div>
</template>

<script>
import FirmaArchivo from "./FirmaArchivo.vue";
import MailArchivo from "./MailArchivo.vue";
import { myMSALObj, signIn } from "../services/msalService";
if (!myMSALObj.getAccount()) {
  signIn();
}
export default {
  components: { FirmaArchivo, MailArchivo },
  data() {
    return {
      account: myMSALObj.getAccount(),
      idDocumento: ""
    };
  },
  computed: {
    mailVisible: function() {
      return this.idDocumento != "";
    }
  },
  methods: {
    documentoFirmado: function(idDocumento) {
      this.idDocumento = idDocumento;
    }
  }
};
</script>

<style></style>
